if (!customElements.get("product-form")) {
    customElements.define(
        "product-form",
        class ProductForm extends HTMLElement {
            constructor() {
                super();

                this.form = this.querySelector("form");
                this.form.querySelector("[name=id]").disabled = false;
                this.form.addEventListener("submit", this.onSubmitHandler.bind(this));

                this.cart =
                    document.querySelector("cart-notification") ||
                    document.querySelector("cart-drawer");
                this.submitButton = this.querySelector('[type="submit"]');
                //this.productVariantId = this.form.querySelector('.product-variant-id');

                if (document.querySelector("cart-drawer"))
                    this.submitButton.setAttribute("aria-haspopup", "dialog");

                this.hideErrors = this.dataset.hideErrors === "true";
            }

            onSubmitHandler(evt) {
                if (this.submitButton.classList.contains("disabled")) {
                    evt.preventDefault();
                    this.handleErrorMessage("Bitte wähle deine Produktoptionen.");
                    return false;
                }

                evt.preventDefault();
                if (this.submitButton.getAttribute("aria-disabled") === "true") return;

                this.handleErrorMessage();

                let closestProductForm = $(this);
                let closestProductInfo = $(this).closest("product-info");
                let ActiveProduct = $(this).closest(".active-product");

                let Is_Camp_Section = $(".book_now_wrapper").length;
                //console.log("Is_Camp_Section",Is_Camp_Section);
                if (Is_Camp_Section > 0) {
                    let prod_form = $(evt.submitter).parents("form");
                    if (!$(evt.submitter).parents("form").valid()) {
                        return false;
                    }
                }

                let hidden_product_count = ActiveProduct.find(".hidden_product_input").length;
                var selected_products = [];
                // console.log("hidden_product",hidden_product_count);
                if (hidden_product_count > 0) {

                    let product_form__error_message_wrapper = ActiveProduct.find(".product-form__error-message-wrapper");
                    let product_form__error_message = ActiveProduct.find(".product-form__error-message");                    

                    // for Individuell
                    if (ActiveProduct.find(".trikots-tabs .tab[data-tab='individuell']").hasClass("active")) {
                        let individuell_no = ActiveProduct.find(".individuell_fields .individuell-nummer").val();
                        let individuell_name = ActiveProduct.find(".individuell_fields .individuell-name").val();

                        //console.log("individuell", individuell_no, individuell_name);
                        if (individuell_no || individuell_name) {
                            product_form__error_message_wrapper.attr("hidden", true);
                            product_form__error_message.text("");
                        } else if (individuell_no == "" && individuell_name == "") {
                            product_form__error_message_wrapper.removeAttr("hidden");
                            product_form__error_message.text("Bitte ergänzen Sie Nummer & Name für Individuell.");
                            return false;
                        }
                    }

                    // for Spieler
                    if (ActiveProduct.find(".trikots-tabs .tab[data-tab='spieler']").hasClass("active")) {
                        let spieler_val = ActiveProduct.find(".hidden_product_input .select__select").val();

                        if (spieler_val != 0) {
                            product_form__error_message_wrapper.attr("hidden", true);
                            product_form__error_message.text("");
                        } else if (spieler_val == 0) {
                            product_form__error_message_wrapper.removeAttr("hidden");
                            product_form__error_message.text("Bitte wählen Sie die Spieler aus.");
                            return false;
                        }
                    }

                    // add to cart
                    let hidden_products = ActiveProduct.find(".hidden_product_input");
                    let random_no = Math.floor(Math.random() * 100000000);                    

                    // Loop through all hidden products
                    hidden_products.each(function() {
                        let $hidden_product = $(this);
                        //console.log("$hidden_product", $hidden_product);
                        let product_variant,
                            product_variant_sku,
                            product_option_name,
                            product_option_nummer,
                            product_option_amount,
                            individuell_meta_sku;

                        if ($hidden_product.hasClass("product-form__input--dropdown")) {
                            const $selected = $hidden_product.find(":selected");                            
                            if ($selected.length && $selected.val()){                                
                                product_variant = $selected.data("variantid");
                                product_variant_sku = $selected.data("variant_sku");
                                product_option_nummer = $selected.data("nummer");
                                product_option_amount = $selected.data("amount");
                            }
                        } else {
                            const $checked = $hidden_product.find('input:checked');                            
                            if ($checked.length){                                
                                product_variant = $checked.data("variantid");
                                product_variant_sku = $checked.data("variant_sku");
                                product_option_name = $checked.attr('name');
                                product_option_amount = $checked.data('amount');
                            }
                        }

                        var SKU, SKU_Nummer, FLOCK, Patch = "";
                        if (product_variant) {
                            if (product_variant_sku) {
                                SKU = `${product_variant_sku}`;
                            }

                            if (product_option_nummer) {
                                individuell_meta_sku = $(".active-product").find(`.hidden_product_input[data-content="individuell"] input[type="checkbox"][value="${product_option_nummer}"]`).data('variant_sku');
                                if (individuell_meta_sku) {
                                    SKU_Nummer = `${individuell_meta_sku}`;
                                }
                            }

                            if (
                                product_option_name?.toLowerCase().includes("individuell name") ||
                                product_option_name?.toLowerCase().includes("individuell") ||
                                product_option_name?.toLowerCase().includes("spieler")
                            ) {
                                const flock_val = $(closestProductForm)
                                    .find(".properties_flock")
                                    .val();
                                FLOCK = `${flock_val}`;
                            }

                            const properties = {
                                _TRIKOT: random_no,
                                ...(product_variant_sku && {
                                    SKU: product_variant_sku
                                }),
                                ...(individuell_meta_sku && {
                                    SKU_Nummer: individuell_meta_sku
                                }),
                                ...(FLOCK && {
                                    FLOCK: FLOCK
                                })
                            };

                            if (
                                typeof product_option_amount !== "undefined" &&
                                window.aico_percentage_discount &&
                                window.aico_percentage_discount != 0
                            ) {
                                product_option_amount = applyAicoDiscount(
                                    product_option_amount
                                );
                                properties._price_item_discount = product_option_amount;
                            }

                            selected_products.push({
                                quantity: 1,
                                id: product_variant,
                                properties
                            });
                        }
                    });

                    if (selected_products.length > 0) {
                      ActiveProduct.find(".properties_trikot").val(random_no);
                    }

                } // hidden_product close

                console.log("selected_products", JSON.stringify(selected_products));

                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButton.classList.add("loading");
                this.querySelector(".loading__spinner").classList.remove("hidden");

                // ✅ Append `selected_products` to FormData
                var formData = "";
                if (selected_products.length > 0) {                    

                    formData = new FormData();

                    // ✅ Append `selected_products` first
                    selected_products.forEach((product, index) => {
                        formData.append(`items[${index}][id]`, product.id);
                        formData.append(`items[${index}][quantity]`, product.quantity);

                        // Append properties if they exist
                        if (product.properties) {
                            Object.keys(product.properties).forEach((key) => {
                                formData.append(`items[${index}][properties][${key}]`,
                                    product.properties[key]
                                );
                            });
                        }
                    });

                    const formProductIndex = selected_products.length; // Continue the index
                    formData.append(`items[${formProductIndex}][id]`,
                        this.form.querySelector('[name="id"]').value
                    );
                    formData.append(`items[${formProductIndex}][quantity]`, 1);

                    // If the main product has properties, add them
                    const formProperties = new FormData(this.form);
                    for (const [key, value] of formProperties.entries()) {
                        if (key.startsWith("properties[") && value.trim() !== "") {
                          formData.append(`items[${formProductIndex}][${key}]`, value);
                        }
                    }
                } else {
                  
                    const originalFormData = new FormData(this.form);
                    formData = new FormData();
                    
                    for (const [key, value] of originalFormData.entries()) {
                      if (key.startsWith("properties[")) {
                        // Only add property if value is not empty or whitespace-only
                        if (value.trim() !== "") {
                          formData.append(key, value.trim());
                        }
                      } else {
                        // Keep all other fields (like id, quantity)
                        formData.append(key, value);
                      }
                    }
                }

                if (this.cart) {
                    formData.append(
                        "sections",
                        this.cart.getSectionsToRender()
                        .filter((section) => section) // filter out null/undefined
                        .map((section) => section.id)
                    );
                    formData.append("sections_url", window.location.pathname);
                    this.cart.setActiveElement(document.activeElement);
                }

                const config = fetchConfig("javascript");
                config.headers["X-Requested-With"] = "XMLHttpRequest";
                delete config.headers["Content-Type"];
                config.body = formData;

                fetch(`${routes.cart_add_url}`, config)
                    .then((response) => response.json())
                    .then((response) => {
                        if (response.status) {
                            //console.log(response.status,Is_Camp_Section)

                            publish(PUB_SUB_EVENTS.cartError, {
                                source: "product-form",
                                productVariantId: formData.get("id"),
                                errors: response.errors || response.description,
                                message: response.message,
                            });
                            this.handleErrorMessage(response.description);

                            const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
                            if (!soldOutMessage) return;
                            this.submitButton.setAttribute("aria-disabled", true);
                            this.submitButton.querySelector("span").classList.add("hidden");
                            soldOutMessage.classList.remove("hidden");
                            this.error = true;
                            return;
                        } else if (!this.cart) {
                            window.location = window.routes.cart_url;
                            return;
                        }

                        if (Is_Camp_Section > 0) {
                            window.location = window.routes.cart_url;
                            // window.location = `/checkout`;
                            return;
                        }
                        //console.log(response,Is_Camp_Section)
                        if (!this.error)
                            publish(PUB_SUB_EVENTS.cartUpdate, {
                                source: "product-form",
                                productVariantId: formData.get("id"),
                                cartData: response,
                            });
                        this.error = false;
                        const quickAddModal = this.closest("quick-add-modal");
                        if (quickAddModal) {
                            document.body.addEventListener(
                                "modalClosed",
                                () => {
                                    setTimeout(() => {
                                        this.cart.renderContents(response);
                                    });
                                }, {
                                    once: true
                                }
                            );
                            quickAddModal.hide(true);
                        } else {
                            this.cart.renderContents(response);
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                    })
                    .finally(() => {
                        this.submitButton.classList.remove("loading");
                        if (this.cart && this.cart.classList.contains("is-empty"))
                            this.cart.classList.remove("is-empty");
                        if (!this.error) this.submitButton.removeAttribute("aria-disabled");
                        this.querySelector(".loading__spinner").classList.add("hidden");

                        // close upsell modal
                        if (
                            this.submitButton.classList.contains("product-upsell__submit")
                        ) {
                            document.body.classList.remove("overflow-hidden", "open-popup");
                            document.querySelectorAll(".modal").forEach((el) => {
                                el.style.display = "none";
                            });
                        }
                        // reset the quick buy options for the card grid
                        if (
                            this.submitButton.classList.contains("quick-add__submit") ||
                            this.submitButton.classList.contains("quick_buy_submit")
                        ) {
                            const card = this.submitButton.closest(".card");
                            if (card) {
                                card.classList.remove("card-active");

                                const firstInputGroup = card.querySelector(
                                    "variant-selects .product-form__input"
                                );
                                if (firstInputGroup) {
                                    const radios = firstInputGroup.querySelectorAll('input[type="radio"]');
                                    radios.forEach((radio) => {
                                        radio.checked = false;
                                    });
                                }
                            }
                        }
                    });
            }

            handleErrorMessage(errorMessage = false) {
                if (this.hideErrors) return;

                this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
                if (!this.errorMessageWrapper) return;
                this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

                this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

                if (errorMessage) {
                    this.errorMessage.textContent = errorMessage;
                }
            }
        }
    );
}